import { getPrefixedSnackbar } from '@genesislcap/foundation-ui';
import { html } from '@microsoft/fast-element';
export const zeroSnackbarTemplate = html `
  ${getPrefixedSnackbar('zero')}
`;
